import type {
	Components,
} from '@mui/material'

export const materialUIMenuTheme: {
	components: Components
} = {
	components: {
		MuiMenu: {
			styleOverrides: {
				paper: {
					backgroundColor: 'var(--surface-container-color)',
					borderRadius:    'var(--border-radius-s)',
					boxShadow:        'var(--base-box-shadow)',
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					color:      'var(--on-surface-color)',
					fontSize:   'var(--font-size-body-x-small)',
					padding:    'var(--base-spacing-1) var(--base-spacing-2)',
					minHeight:  '20px',
					fontWeight: 500,
				},
			},
		},
	},
}
